import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './TournamentsTable.module.scss';
import { ITournament } from '../../../../types/ITournament';
import { format } from 'date-fns';
import { DATE_FORMAT } from '../../../../constants';
import { getStatusColor } from '../../../../api/tournament';

const tableHeader: string[] = ['ID', 'NAME', 'GAME', 'VERSION', 'PARTICIPANTS', 'START DATE', 'END DATE', 'STATUS', 'ENTRY FEE'];

interface ITournamentsTableProps {
    data: ITournament[] | undefined;
}

export const TournamentsTable = ({ data }: ITournamentsTableProps): React.JSX.Element => {
    const navigate = useNavigate();

    if (!data) return <></>;

    return (
        <div className={styles.container}>
            <table className={styles.table}>
                <thead>
                    <tr>
                        {tableHeader.map((h) => (
                            <td key={h}>{h}</td>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {data.map((tournament, idx) => (
                        <tr
                            key={tournament.id}
                            className={[idx % 2 ? '' : styles.grayColl, styles.clickable].join(' ')}
                            onClick={() => navigate(`/tournaments/${tournament.id}`)}
                        >
                            <td>{tournament.id}</td>
                            <td>{tournament.name}</td>
                            <td>{tournament.game}</td>
                            <td>{tournament.gameVersion}</td>
                            <td>{tournament.participantsAmount} / {tournament.totalParticipants}</td>
                            <td>{format(new Date(tournament.startDate), DATE_FORMAT)}</td>
                            <td>{format(new Date(tournament.endDate), DATE_FORMAT)}</td>
                            <td>
                                <div className={styles.statusBadge} style={{ backgroundColor: getStatusColor(tournament.status).bg, color: getStatusColor(tournament.status).text }}>
                                    {tournament.status}
                                </div>
                            </td>
                            <td>{tournament.bet}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};
